<app-layout-container [fluid]="true">
    <!-- Header -->
    <app-layout-row>
        <app-layout-column [width]="12">
            <div class="headersection">
                <div>
                    @if (status().toString() === 'PartnerDone') {
                    <div class="portalheader">Welcome back to the Partner Onboarding</div>
                    <div class="sectionheader">Onboarding in progress...</div>
                    <p class="portalheadertext">Thank you for submitting your onboarding information.</p>
                    <p class="portalheadertext">We are currently reviewing the details you provided to ensure everything
                        is in order. Our team will get back to you shortly if we require any additional information or
                        clarification.</p>
                    <p class="portalheadertext">In the meantime, you can review the information you provided below. If
                        you need to make any changes or have any questions, please don't hesitate to reach out to us by
                        using the comments feature.</p>
                    <p class="portalheadertext">We appreciate your cooperation and look forward to working with you!</p>
                    }
                    @else {
                    <div class="portalheader">Welcome to the Partner Onboarding</div>
                    <p class="portalheadertext">This onboarding form is designed to gather essential information about
                        your company and its capabilities as a trading partner.</p>
                    <p class="portalheadertext">The onboarding process consists of six steps, each focusing on a
                        specific aspect of the partnership. Please follow the steps in order to ensure a successful
                        onboarding experience.</p>
                    <p class="portalheadertext">If you are unsure about any of the fields, please use the comment
                        feature available on each section to ask for clarification or assistance.</p>
                    <p class="portalheadertext">You can save your progress at any time by clicking the "Save - and
                        continue later" button at the bottom of the form.</p>
                    <p class="portalheadertext">Once you have completed all the steps, click the "Submit" button at the
                        bottom of the form to send your information for review.</p>
                    }
                </div>
                <div class="headerlogo">
                    @if (showLogoOnPartnerPortal())
                    {
                    <app-image-display 
                        [base64Image]="$safeNavigationMigration(companyProfile()?.Logo)" 
                        width="275px" 
                        height="80px"
                        [scaleImageToCell]="true"
                        [shrinkCellToFit]="true"
                        [blockMode]="false"
                        [altText]="'Company Logo'" 
                        [showPlaceholder]="false" 
                        placeholderText="No logo uploaded">
                    </app-image-display>
                    }
                </div>
            </div>
        </app-layout-column>
    </app-layout-row>

    <!-- Status -->
    <app-layout-row margin="4rem" min-width="900px">
        <app-layout-column [width]="12" [offset]="0">
            @if (isOpenedByCustomer())
            {
            <div class="status-box">
                <i class="dx-icon-info status-icon read-only"></i>
                <p class="status-text">You are viewing this form in read-only mode. Only the partner can save changes to
                    the onboarding data.</p>
                <app-button tertiery (click)="switchUserProfile()">Switch to partner view.</app-button>
            </div>
            }
            @else
            {
            <div class="status-box">
                @if (statusText()) {
                <i [class]="'status-icon ' + statusIconClass"></i>

                <p class="status-text">
                    {{statusText()}}
                </p>
                }
            </div>
            }
        </app-layout-column>
    </app-layout-row>

    <!-- Form -->
    <app-layout-row>
        <app-layout-column [width]="12" [offset]="0">
            <form (ngSubmit)="save(false)" #tForm="ngForm">
                <div class="form-layout">
                    <div class="form-navigation">
                        <!-- Stepper -->
                        <app-layout-row>
                            <app-layout-column [width]="12">
                                <app-onboarding-stepper [currentStepId]="currentStepId()" [steps]="steps()"
                                    (stepChanged)="goToStep($event)"></app-onboarding-stepper>
                            </app-layout-column>
                        </app-layout-row>
                    </div>

                    <div class="form-content">
                        <!-- Company name -->
                        <app-layout-row [class.form-section-hidden]="currentStepId()!=='step-company-name'">
                            <app-layout-column [width]="12">
                                <div class="sectionheader">Please provide a company name</div>
                                <p>e.g. My Company Name A/S</p>
                                <app-layout-row margin="2rem">
                                    <app-layout-column [width]="12">
                                        <app-onboarding-field required [ngModel]="$safeNavigationMigration(model()?.Name)" valueExpr="Name"
                                            name="name" caption="Company Name"
                                            [readonly]="isStatusReadOnly($safeNavigationMigration(model()?.Name.Status))"
                                            [allowConversation]="!isOpenedByCustomer()"
                                            [readonlyConversation]="overrideUserProfile()"
                                            [conversation]="visibleConversation()"
                                            [unreadConversationIds]="unreadConversationIds()"
                                            [autoRefreshEnabled]="autoRefreshConversations()"
                                            (toggleAutoRefreshClicked)="onToggleAutoRefreshConversations()"
                                            (toggleConversationClicked)="onToggleConversation($event)"
                                            (newCommentClicked)="onNewComment($event)"
                                            (formStatusChanged)="onFormStatusChanged($event, 'companyName')">
                                        </app-onboarding-field>
                                    </app-layout-column>
                                </app-layout-row>
                            </app-layout-column>
                        </app-layout-row>

                        <!-- Contact -->
                        <app-layout-row [class.form-section-hidden]="currentStepId()!=='step-contact'">
                            <app-layout-column [width]="12">
                                <div class="sectionheader">How can we contact you?</div>
                                <p>The e-mail adress will also be used as contact, if something goes wrong. This can be
                                    changed later.</p>
                                <app-layout-row margin="2rem">
                                    <app-layout-column [width]="12">
                                        <app-onboarding-field required [ngModel]="$safeNavigationMigration(model()?.Contact.Name)"
                                            valueExpr="ContactName" name="contactName" caption="Name of contact person"
                                            [readonly]="isStatusReadOnly($safeNavigationMigration(model()?.Contact.Name?.Status))"
                                            [allowConversation]="!isOpenedByCustomer()"
                                            [readonlyConversation]="overrideUserProfile()"
                                            [conversation]="visibleConversation()"
                                            [unreadConversationIds]="unreadConversationIds()"
                                            [autoRefreshEnabled]="autoRefreshConversations()"
                                            (toggleAutoRefreshClicked)="onToggleAutoRefreshConversations()"
                                            (toggleConversationClicked)="onToggleConversation($event)"
                                            (newCommentClicked)="onNewComment($event)"
                                            (formStatusChanged)="onFormStatusChanged($event, 'contactName')">
                                        </app-onboarding-field>
                                    </app-layout-column>
                                </app-layout-row>
                                <app-layout-row margin="2rem">
                                    <app-layout-column [width]="12">
                                        <app-onboarding-field required [ngModel]="$safeNavigationMigration(model()?.Contact.Email)"
                                            valueExpr="ContactEmail" name="contactEmail" caption="Contact email"
                                            [readonly]="isStatusReadOnly($safeNavigationMigration(model()?.Contact.Email?.Status))"
                                            [allowConversation]="!isOpenedByCustomer()"
                                            [readonlyConversation]="overrideUserProfile()"
                                            [conversation]="visibleConversation()"
                                            [unreadConversationIds]="unreadConversationIds()"
                                            [autoRefreshEnabled]="autoRefreshConversations()"
                                            (toggleAutoRefreshClicked)="onToggleAutoRefreshConversations()"
                                            (toggleConversationClicked)="onToggleConversation($event)"
                                            (newCommentClicked)="onNewComment($event)"
                                            (formStatusChanged)="onFormStatusChanged($event, 'contactEmail')">
                                        </app-onboarding-field>
                                    </app-layout-column>
                                </app-layout-row>
                                <app-layout-row margin="2rem">
                                    <app-layout-column [width]="12">
                                        <app-onboarding-field [ngModel]="$safeNavigationMigration(model()?.Contact.PhoneNumber)"
                                            valueExpr="PhoneNumber" name="contactPhone" caption="Phone number"
                                            [readonly]="isStatusReadOnly($safeNavigationMigration(model()?.Contact.PhoneNumber?.Status))"
                                            [allowConversation]="!isOpenedByCustomer()"
                                            [readonlyConversation]="overrideUserProfile()"
                                            [conversation]="visibleConversation()"
                                            [unreadConversationIds]="unreadConversationIds()"
                                            [autoRefreshEnabled]="autoRefreshConversations()"
                                            (toggleAutoRefreshClicked)="onToggleAutoRefreshConversations()"
                                            (toggleConversationClicked)="onToggleConversation($event)"
                                            (newCommentClicked)="onNewComment($event)"
                                            (formStatusChanged)="onFormStatusChanged($event, 'contactPhone')">
                                        </app-onboarding-field>
                                    </app-layout-column>
                                </app-layout-row>
                            </app-layout-column>
                        </app-layout-row>

                        <!-- Identifiers -->
                        <app-layout-row [class.form-section-hidden]="currentStepId()!=='step-identifications'">
                            <app-layout-column [width]="12">
                                <div class="sectionheader">We need an identifier</div>
                                <p>This could be in the form of af GLN, CVR number or something mutually agreed upon.
                                </p>
                                <p>Identifiers could be:</p>
                                <ul>
                                    <li><b>GLN (Global Location Number)</b>: Used to identify locations and legal
                                        entities.</li>
                                    <li><b>CVR (Centrale Virksomhedsregister)</b>: Unique business identifier</li>
                                    <li><b>Mutually Defined Identifier</b>: A custom identifier agreed upon by trading
                                        partners.</li>
                                </ul>
                                <p>Below are listed the identifiers you can choose from as default.<br>Identifiers not
                                    listed below can be added by clicking "Add Additional Identifiers"</p>
                                <app-layout-row margin="2rem">
                                    <app-layout-column [width]="12">
                                        <app-onboarding-identifications name="identifications"
                                            [readonly]="status() !== 'InProgress'" [ngModel]="$safeNavigationMigration(model()?.Identifications)"
                                            [possibleIdentificationTypes]="setup()?.IdentificationTypes ?? []"
                                            [allowConversation]="!isOpenedByCustomer()"
                                            [readonlyConversation]="overrideUserProfile()"
                                            [conversation]="visibleConversation()"
                                            [unreadConversationIds]="unreadConversationIds()"
                                            [autoRefreshEnabled]="autoRefreshConversations()"
                                            (toggleAutoRefreshClicked)="onToggleAutoRefreshConversations()"
                                            (toggleConversationClicked)="onToggleConversation($event)"
                                            (newCommentClicked)="onNewComment($event)"
                                            (formStatusChanged)="onFormStatusChanged($event, 'identifications')">
                                        </app-onboarding-identifications>
                                    </app-layout-column>
                                </app-layout-row>
                            </app-layout-column>
                        </app-layout-row>

                        <!-- Document types to send -->
                        <app-layout-row [class.form-section-hidden]="currentStepId()!=='step-document-in'">
                            <app-layout-column [width]="12">
                                <div class="sectionheader">What kinds of documents would you like to send to us?</div>
                                <p>Please specify the types of documents you're interested in sending.</p>
                                <ul>
                                    <li>If a specific document is not in the list you can add it by specifying the
                                        document type and the format.</li>
                                    <li>If the document is present but your format is not, you can choose "Other" from
                                        the list and specify the format you prefer.</li>
                                </ul>
                                <app-layout-row margin="2rem">
                                    <app-layout-column [width]="12">
                                        <app-onboarding-documents 
                                            name="documentTypesIn" 
                                            [readonly]="status() !== 'InProgress'" 
                                            [ngModel]="$safeNavigationMigration(model()?.DocumentTypesIn)" 
                                            [possibleDocumentTypes]="setup()?.DocumentTypesIn ?? []" 
                                            [possibleTransportTypes]="setup()?.SupportedTransports ?? []" 
                                            [documentDirection]="DocumentDirection.Inbound"
                                            [allowConversation]="!isOpenedByCustomer()"
                                            [readonlyConversation]="overrideUserProfile()"
                                            [conversation]="visibleConversation()" 
                                            [unreadConversationIds]="unreadConversationIds()"
                                            [autoRefreshEnabled]="autoRefreshConversations()"
                                            (toggleAutoRefreshClicked)="onToggleAutoRefreshConversations()"
                                            (toggleConversationClicked)="onToggleConversation($event)" 
                                            (newCommentClicked)="onNewComment($event)"
                                            (formStatusChanged)="onFormStatusChanged($event, 'documentTypesIn')"
                                            (requestCredentialsClicked)="requestCredentials($event)"
                                            (showCredentialsClicked)="showCredentials($event)">
                                        </app-onboarding-documents>
                                    </app-layout-column>
                                </app-layout-row>
                            </app-layout-column>
                        </app-layout-row>

                        <!-- Document types to receive -->
                        <app-layout-row [class.form-section-hidden]="currentStepId()!=='step-document-out'">
                            <app-layout-column [width]="12">
                                <div class="sectionheader">What kinds of documents would you like to receive from us?
                                </div>
                                <p>Please specify the types of documents you're interested in receiving.</p>
                                <ul>
                                    <li>If a specific document is not in the list you can add it by specifying the
                                        document type and the format.</li>
                                    <li>If the document is present but your format is not, you can choose "Other" from
                                        the list and specify the format you prefer.</li>
                                </ul>
                                <app-layout-row margin="2rem">
                                    <app-layout-column [width]="12">
                                        <app-onboarding-documents 
                                            name="documentTypesOut" 
                                            [readonly]="status() !== 'InProgress'" 
                                            [ngModel]="$safeNavigationMigration(model()?.DocumentTypesOut)" 
                                            [possibleDocumentTypes]="setup()?.DocumentTypesOut ?? []" 
                                            [possibleTransportTypes]="setup()?.SupportedTransports ?? []" 
                                            [documentDirection]="DocumentDirection.Outbound"
                                            [allowConversation]="!isOpenedByCustomer()"
                                            [readonlyConversation]="overrideUserProfile()"
                                            [conversation]="visibleConversation()" 
                                            [unreadConversationIds]="unreadConversationIds()"
                                            [autoRefreshEnabled]="autoRefreshConversations()"
                                            (toggleAutoRefreshClicked)="onToggleAutoRefreshConversations()" 
                                            (toggleConversationClicked)="onToggleConversation($event)" 
                                            (newCommentClicked)="onNewComment($event)"
                                            (formStatusChanged)="onFormStatusChanged($event, 'documentTypesOut')"
                                            (requestCredentialsClicked)="requestCredentials($event)"
                                            (showCredentialsClicked)="showCredentials($event)">
                                        </app-onboarding-documents>
                                    </app-layout-column>
                                </app-layout-row>
                            </app-layout-column>
                        </app-layout-row>

                        <!-- Additional notes -->
                        <app-layout-row [class.form-section-hidden]="currentStepId()!=='step-anything-else'">
                            <app-layout-column [width]="12">
                                <div class="sectionheader">Anything else?</div>
                                <p>Connection types, or any other form of customizations needed.</p>
                                <app-layout-row margin="2rem">
                                    <app-layout-column [width]="12">
                                        <div #notes class="link-component">
                                            <dx-text-area
                                                name="note"
                                                [height]="300"
                                                [ngModel]="$safeNavigationMigration(model()?.Note)"
                                                [autoResizeEnabled]="false"
                                                [inputAttr]="{ 'aria-label': 'Notes' }"
                                                [readOnly]="status() !== 'InProgress'">
                                            </dx-text-area>
                                        </div>
                                    </app-layout-column>
                                </app-layout-row>
                            </app-layout-column>
                        </app-layout-row>

                        <!-- Navigation buttons -->
                        <app-layout-row>
                            <app-layout-column [width]="12">
                                <div class="nav-container">
                                    <div></div>
                                    <p>{{currentStepNumber()}}/{{totalSteps()}}</p>
                                    <div class="nav-buttons">
                                        <app-link (onClick)="goToPrevStep()" [disabled]="prevDisabled()">Back</app-link>
                                        <app-link (onClick)="goToNextStep()" [disabled]="nextDisabled()">Continue</app-link>
                                    </div>
                                </div>
                            </app-layout-column>
                        </app-layout-row>

                    </div>
                </div>
            </form>
        </app-layout-column>
    </app-layout-row>

    <!-- Footer -->
    <app-layout-row>
        <app-layout-column [width]="12">
            <div class="fixed-footer">
                <div class="footerbuttons">
                    <app-button secondary (click)="save(false)" [disabled]="tForm.invalid || !isFormOpen() || isOpenedByCustomer()">Save - and continue later</app-button>
                    <app-button primary (click)="showSendDialog()" [disabled]="tForm.invalid || !isFormOpen() || isOpenedByCustomer()">Submit</app-button>
                </div>
            </div>
        </app-layout-column>
    </app-layout-row>

</app-layout-container>